export default __webpack_public_path__ + "static/media/plan-pic.ad8e8ca4.png";